import React, { Component } from "react"

import LayoutHeaderMenu from "../LayoutHeaderMenu/LayoutHeaderMenu"

import Button from "../Button/Button"
import Layout5 from "../Layout5/Layout5"

import PhoneIphoneIcon from "@material-ui/icons/PhoneIphone"
import LocationOnIcon from "@material-ui/icons/LocationOn"
import FacebookIcon from "@material-ui/icons/Facebook"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import TwitterIcon from "@material-ui/icons/Twitter"

import TextField from "@material-ui/core/TextField"

import GoogleMapReact from "google-map-react"

import ReCAPTCHA from "react-google-recaptcha"
import recaptchaRef from "../../components/recaptchaRef"

import "./contactUs.scss"
// import i18n from "../../translation/i18next"
// import { withTranslation } from "react-i18next"

class ContactUs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: "",
      email: "",
      emailSuccess: false,
      emailError: "",
      text: "",
    }
  }

  handleNameChange = (e) => {
    this.setState({
      name: e.target.value,
    })
  }
  handleEmailChange = (e) => {
    this.setState(
      {
        email: e.target.value,
      },
      () => {
        if (this.emailValidation()) {
          this.setState({
            emailError: false,
          })
        } else {
          this.setState({
            emailError: true,
          })
        }
      }
    )
  }
  handleTextChange = (e) => {
    this.setState({
      text: e.target.value,
    })
  }

  emailValidation = () => {
    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    return regex.test(this.state.email)
  }

  getResult = () => {
    recaptchaRef.current.execute()
  }

  onChange = (token) => {
    fetch(`${process.env.GATSBY_AZURE_URL}/registration`, {
      method: "POST",
      body: JSON.stringify({
        g_recaptcha_response: token,
        name: this.state.name,
        email: this.state.email,
        text: this.state.text,
      }),
    }).then((data) => {
      if (data.statusText === "OK" && data.status === 200) {
        return "OK"
      }
    })
  }

  renderMarkers(map, maps) {
    let marker = new maps.Marker({
      position: {
        lat: 46.91812,
        lng: 19.682175,
      },
      map,
      title: this.props.pageContext.content.contact.text_address,
    })
  }

  render() {
    const {
      set_metadata,
      text_header_title,
      text_header_description,
      text_address,
      text_button_text,
      text_description,
      text_email,
      text_facebook,
      text_linkedin,
      text_mobile,
      text_name,
      text_title,
      text_twitter,
    } = this.props.pageContext.content.contact

    const siteMetadata = {
      title: set_metadata.text_page_title,
      description: set_metadata.text_page_description,
      meta: [
        {
          name: "keywords",
          content: set_metadata.text_keywords,
        },
      ],
      author: `prodHost`,
    }
    return (
      <div className="contact-us-wrapper">
        <ReCAPTCHA
          ref={recaptchaRef}
          size="invisible"
          sitekey={process.env.GATSBY_CAPTCHA_SITE_KEY}
          onChange={this.onChange}
        />
        <LayoutHeaderMenu
          siteMetadata={siteMetadata}
          header_logo={
            this.props.pageContext.content.global_values.set_logos
              .asset_prodhost_logo_white_120p
          }
          header_title={text_header_title}
          header_description={text_header_description}
          header_background={``}
          captcha
          header_shaded
          menu={this.props.pageContext.menu.entries}
          footer={this.props.pageContext.content.global_values.set_footer}
        >
          <div className="contact-us-body">
            <div className="contact-us-main">
              <div className="contact-us-map-wrapper">
                <div className="contact-us-map">
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: process.env.GATSBY_GOOGLE_MAPS_KEY,
                    }}
                    defaultCenter={{
                      lat: 46.91812,
                      lng: 19.682175,
                    }}
                    defaultZoom={15}
                    onGoogleApiLoaded={({ map, maps }) =>
                      this.renderMarkers(map, maps)
                    }
                  ></GoogleMapReact>
                </div>
                <div className="contact-us-contacts">
                  <div className="contact-us-contacts-phone row-logo">
                    <div className="logo-wrapper">
                      <PhoneIphoneIcon />
                    </div>
                    <div className="contact-us-contacts-phone-text row-logo-text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`tel:${text_mobile}`}
                      >
                        {text_mobile}
                      </a>
                    </div>
                  </div>
                  <div className="contact-us-contacts-address row-logo">
                    <div className="logo-wrapper">
                      <LocationOnIcon />
                    </div>
                    <div className="contact-us-contacts-address-text row-logo-text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://google.com/maps/place/${text_address
                          .split(" ")
                          .join("+")}`}
                      >
                        {text_address}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="contact-us-form-wrapper">
                <Layout5 title={text_title} description={""}>
                  <div className="contact-us-form-send-wrapper">
                    <TextField
                      id="outlined-basic_1"
                      label={text_description}
                      variant="outlined"
                      className="text-area"
                      multiline={true}
                      onChange={this.handleTextChange}
                    />
                    <div className="contact-us-form-send">
                      <TextField
                        id="outlined-basic_2"
                        label={text_name}
                        variant="outlined"
                        onChange={this.handleNameChange}
                      />
                      <TextField
                        id="outlined-basic_3"
                        label={text_email}
                        error={this.state.emailError ? true : false}
                        helperText={
                          this.state.emailError ? "Nem valós email cím!" : " "
                        }
                        variant="outlined"
                        onChange={this.handleEmailChange}
                      />
                      <Button
                        type={"primary"}
                        text={text_button_text}
                        onClick={() => {
                          if (
                            this.state.name.length > 0 &&
                            this.state.text.length > 0 &&
                            this.state.emailError === false
                          ) {
                            console.log(this.state)
                          }
                        }}
                      />
                    </div>
                  </div>
                </Layout5>
                <div className="contact-us-links">
                  <div className="row-logo">
                    <div className="logo-wrapper">
                      <FacebookIcon />
                    </div>
                    <div className="contact-us-links-facebook row-logo-text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://${text_facebook}`}
                      >
                        {text_facebook}
                      </a>
                    </div>
                  </div>
                  <div className="row-logo">
                    <div className="logo-wrapper">
                      <LinkedInIcon />
                    </div>
                    <div className="contact-us-links-linkedin row-logo-text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://${text_linkedin}`}
                      >
                        {text_linkedin}
                      </a>
                    </div>
                  </div>
                  <div className="row-logo">
                    <div className="logo-wrapper">
                      <TwitterIcon />
                    </div>
                    <div className="contact-us-links-twitter row-logo-text">
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={`https://${text_twitter}`}
                      >
                        {text_twitter}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LayoutHeaderMenu>
      </div>
    )
  }
}

export default ContactUs
